import React, { PropsWithChildren, ReactNode } from "react"
import { Button as MuiButton, SxProps, Theme, ButtonBaseProps } from "@mui/material"

export type PrimitiveButtonProps = PropsWithChildren<{
	variant: "contained" | "outlined" | "text"
	size: "medium" | "large" | "small"
	onClick?: ButtonBaseProps["onClick"]
	sx?: SxProps<Theme>
	startIcon?: ReactNode
	endIcon?: ReactNode
	disabled?: boolean
}>

export const PrimitiveButton = ({
	children,
	...props
}: PrimitiveButtonProps) => {
	return <MuiButton
		{...props}
	>
		{children}
	</MuiButton>
}